<div *ngIf="!!loading; else content" class="d-flex flex-center">
  <img class="spinner" src="assets/gif/spinner.gif" />
</div>

<ng-template #content>
  <ng-content></ng-content>
</ng-template>
